import { render, staticRenderFns } from "./mpage.vue?vue&type=template&id=20d6f5ec&scoped=true&"
import script from "./mpage.vue?vue&type=script&lang=js&"
export * from "./mpage.vue?vue&type=script&lang=js&"
import style0 from "./mpage.vue?vue&type=style&index=0&id=20d6f5ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d6f5ec",
  null
  
)

export default component.exports